import { Tag } from 'antd';
import React, { memo } from 'react';
import classnames from 'classnames';

import style1 from './index.less';

type Data = Array<Record<'label' | 'value', string>>;

const data: Data = [
  { label: 'tag-white', value: '#fff' },
  { label: 'tag-goldenrod', value: '#ffb652' },
  { label: 'tag-sienna', value: '#b59177' },
  { label: 'tag-seagreen', value: '#6fd048' },
  { label: 'tag-navyblue', value: '#9264cd' },
  { label: 'tag-orchid', value: '#fc7cb3' },
  { label: 'tag-tomato', value: '#ff8947' },
  { label: 'tag-green', value: '#00ce7d' },
  { label: 'tag-blue', value: '#4ca0ff' },
  { label: 'tag-red', value: '#ff5c5e' },
  { label: 'tag-gray', value: '#707070' }
];

interface MyTag extends React.FC<TagProps> {
  BorderTag: React.FC<TagProps>;
  color: Data;
}

const MyTag: MyTag = ({
  label,
  color = 'tag-white',
  children,
  style,
  className = '',
  maxStringLength = 8,
  closable,
  onClose,
  onClick,
  visible = true,
  afterClose
}) => {
  const select = data.find(value => value.label === color) || {
    value: 'tag-white'
  };
  const title = label || '';

  if (!visible) return null;

  return (
    <Tag
      className={classnames(className, style1['myTag'])}
      title={label}
      color={select.value}
      style={style}
      closable={closable}
      onClose={onClose}
      onClick={onClick}>
      <span>{title}</span>
      {children}
    </Tag>
  );
};

const BorderTag = memo<TagProps>(
  ({
    label,
    color = 'tag-white',
    children,
    className = '',
    maxStringLength = 8,
    style: tagStyle,
    closable,
    onClose,
    onClick,
    visible = true,
    afterClose
  }) => {
    const title = label || '';

    if (!visible) return null;

    return (
      <Tag
        className={classnames(className, style1[color], style1['border-tag'], style1['myTag'])}
        title={label}
        style={tagStyle}
        closable={closable}
        onClick={onClick}
        onClose={onClose}>
        <span>{title}</span>
        {children}
      </Tag>
    );
  }
);

MyTag.BorderTag = BorderTag;
MyTag.color = data;

export default MyTag;
